// Used to identify types of telemetry events in AppHost
export var AppHostElement;
(function (AppHostElement) {
    AppHostElement["About"] = "ABOUT";
    AppHostElement["AppPermissions"] = "APP_PERMISSIONS";
    AppHostElement["OpenBrowser"] = "OPEN_BROWSER";
    AppHostElement["Refresh"] = "REFRESH";
    AppHostElement["Retry"] = "RETRY";
    AppHostElement["Tab"] = "TAB";
})(AppHostElement || (AppHostElement = {}));
//# sourceMappingURL=AppHostElement.js.map